import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { findWithUUID } from '@/utils/uuidHelper';
import { nextCarouselItem, previousCarouselitem } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import SaveButton from '@/components/buttons/SaveButton';
import { updateActiveField } from '../../dictionaries/actions';
import { canEditDataset } from '../../helper';

const DictionaryFieldActions = ({
  onClose,
  onSave,
  changeField,
  fields,
  fieldUUID,
  canEdit,
  isDirty,
  saveStatus,
}) => (
  <Modal.Actions>
    <CloseButton onClick={onClose} />
    {fields.length > 1 && (
    <>
      <BackButton onClick={() => changeField(previousCarouselitem(fields, fieldUUID, 'uuid'))} />
      <ForwardButton onClick={() => changeField(nextCarouselItem(fields, fieldUUID, 'uuid'))} />
    </>
    )}
    {canEdit && (
    <SaveButton
      inProgress={saveStatus === states.PENDING}
      messageId="actions.apply.changes"
      minimumDataEntryMet={isDirty}
      onClick={onSave}
    />
    )}
  </Modal.Actions>
);

const mapStateToProps = ({
  auth: { role },
  datasets: { lookups },
}) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  const fields = dictionary ? dictionary.fields || [] : [];

  return (
    {
      canEdit: canEditDataset(lookups, role),
      fields,
      fieldUUID: lookups.activeFieldUUID,
      isDirty: lookups.isDirty,
      saveStatus: lookups.saveStatus,
    }
  );
};

const mapDispatchToProps = {
  changeField: updateActiveField,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldActions);
